import React from 'react'
import Pergunta from '../../components/Pergunta/Pergunta'

const Jogo = () => (
  <div>
    <Pergunta />
  </div>
)

export default Jogo
